import { useEffect } from "react";
import api from "@/lib/api";

// Heartbeat for the Back Office live view: which page this signed-in device is on (route change + every 30 s).
// A 401 here (session revoked from the Back Office) bubbles through the api interceptor → "kingly:auth-lost".
export function usePresence(user, pathname) {
  useEffect(() => {
    if (!user || user.demo) return undefined;
    const ping = () => {
      if (document.visibilityState !== "visible") return;
      api.post("/auth/ping", { page: window.location.pathname })
        .then((r) => window.dispatchEvent(new CustomEvent("kingly:approvals", { detail: r.data?.approvals || 0 })))
        .catch(() => {});
    };
    ping();
    const id = setInterval(ping, 15000);
    document.addEventListener("visibilitychange", ping);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", ping); };
  }, [user, pathname]);
}
